import { IGlobalProductEntity, PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { ObjectValues } from 'helpers/types';

export const getProductFieldsForRevenuePlan = (product: IGlobalProductEntity) => {
  return {
    productName: product[PRODUCT_NAMES.NAME],
    productPrice: product[PRODUCT_NAMES.PRICE],
    monthlySalesPlanPhysical: product[PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL],
    annualSalesGrowthRate: product[PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE],
    annualPriceGrowthRate: product[PRODUCT_NAMES.ANNUAL_PRICE_GROWTH_RATE],
  };
};

const revenuePlanRequiredFields: ObjectValues<typeof PRODUCT_NAMES>[] = [
  PRODUCT_NAMES.PRICE,
  PRODUCT_NAMES.MONTHLY_SALES_PLAN_PHYSICAL,
];
export const isAllRevenuePlanRequiredFieldsFilled = (product: IGlobalProductEntity): boolean => {
  return revenuePlanRequiredFields.every((requiredField) => !!product[requiredField]);
};
